import { render, staticRenderFns } from "./ProductSelectedElements.vue?vue&type=template&id=1528ea16&"
import script from "./ProductSelectedElements.vue?vue&type=script&lang=js&"
export * from "./ProductSelectedElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports